"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecuteAbilityHandler = exports.ExecuteActorAbilityFactory = exports.ExecuteAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
const Registries_1 = require("../../core/state/Registries");
class ExecuteAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Execute;
        this.__typeName = "Execute";
    }
}
exports.ExecuteAbilityArgs = ExecuteAbilityArgs;
let ExecuteActorAbilityFactory = class ExecuteActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Execute", "OneEnemies", 5);
    }
};
ExecuteActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Execute")
], ExecuteActorAbilityFactory);
exports.ExecuteActorAbilityFactory = ExecuteActorAbilityFactory;
let ExecuteAbilityHandler = class ExecuteAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        if (!container.hasEffectOfType(selectedEnemy, EffectType_1.EffectType.LikeABoss)) {
            container.applyAttack({
                sequence,
                abilityKey: ability.args.__typeName,
                type: "melee",
                attackerId: ability.invokerId,
                targetId: selectedEnemy,
                onHit: sequence => {
                    container.applyEffect(sequence, ability.invokerId, selectedEnemy, new core_1.DeathEffectArgs());
                }
            });
            return;
        }
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 180)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.VulnerabilityEffectArgs(5)
                });
                const bleed = new core_1.BleedingEffectArgs("Power", 10);
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Ticks(8),
                    effect: bleed
                });
            }
        });
    }
};
ExecuteAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Execute)
], ExecuteAbilityHandler);
exports.ExecuteAbilityHandler = ExecuteAbilityHandler;
